import Reflux from 'reflux';
import GroupActions from 'actions/Group';
import AppActions from 'actions/App';
import SteelCompass from 'services/SteelCompass';

var GroupStore = Reflux.createStore({
  listenables: [GroupActions],
  data: {
    list: [],
    buildable: [],
    detail: {},
    sort: {},
    participantCount: null,
    filter: {},
    selection: [],
    selected: null,
    selectionLoading: false
  },
  getInitialState() {
    return this.data;
  },
  init() {
    if (localStorage) {
      var groups = JSON.parse(localStorage.getItem('groups')) || {};
      if (groups.filter) {
        this.data.filter = groups.filter;
      }
      if (groups.sort) {
        this.data.sort = groups.sort;
      }
      this.trigger(this.data);
    }
  },
  serialize() {
    localStorage.setItem(
      'groups',
      JSON.stringify({ filter: this.data.filter, sort: this.data.sort })
    );
  },
  getFilter() {
    return this.data.filter;
  },
  onResetFilter() {
    this.data.filter = {};
    this.trigger(this.data);
    this.serialize();
  },
  onSetFilter(filter) {
    Object.assign(this.data.filter, filter);
    this.trigger(this.data);
    this.serialize();
  },
  onResetSort() {
    this.data.sort = {};
    this.trigger(this.data);
    this.serialize();
  },
  onSetSort(sort) {
    Object.assign(this.data.sort, sort);
    this.trigger(this.data);
    this.serialize();
  },
  hasFilter() {
    return !!this.data.filter.courseId || !!this.data.filter.userId;
  },
  onFetchAll() {
    return SteelCompass.call('search', 'filterCircles', {}, response => {
      this.data.list = response.data;
      this.trigger(this.data);
    });
  },
  onFilter(dontUseFilter) {
    var options = {
      sortBy: this.data.sort.property || 'name',
      sortMode: this.data.sort.direction || 'asc'
    };
    if (!dontUseFilter) {
      options.courseId = this.data.filter.courseId;
      options.userId = this.data.filter.userId;
    }
    return SteelCompass.call('search', 'filterCircles', options, response => {
      this.data.list = response.data;
      this.trigger(this.data);
    });
  },
  onFindBuildable() {
    return SteelCompass.request('circle', 'findBuildable', {}).then(
      buildable => {
        GroupActions.findBuildableComplete(buildable);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onFindBuildableComplete(buildable) {
    this.data.buildable = buildable;
    this.trigger(this.data);
  },
  onCreate(groupName) {
    return SteelCompass.request('circle', 'create', { name: groupName }).then(
      data => {
        GroupActions.createComplete(data);
        this.data.selected = data;
        this.trigger(this.data);
      },
      error => {
        GroupActions.genericError(error);
      }
    );
  },
  onUpdate(circleId, name) {
    return SteelCompass.request('circle', 'update', {
      id: circleId,
      name: name
    }).then(
      () => {
        GroupActions.updateComplete(circleId);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  updateComplete(circleId) {
    GroupActions.findById(circleId);
  },
  onFindByUserId(userId, callback) {
    this.data.selectionLoading = true;
    this.trigger(this.data);
    return SteelCompass.request('search', 'filterCircles', {
      userId: userId,
      sortBy: 'name',
      sortMode: 'asc'
    }).then(
      selection => {
        GroupActions.findByUserIdComplete(selection);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onFindByUserIdComplete(selection) {
    this.data.selection = selection;
    this.data.selectionLoading = false;
    this.trigger(this.data);
  },
  onFindByCourseId(courseId) {
    return SteelCompass.request('search', 'filterCircles', {
      courseId: courseId,
      sortBy: 'name',
      sortMode: 'asc'
    }).then(
      groups => {
        GroupActions.findByCourseIdComplete(groups);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  onFindByCourseIdComplete(groups) {
    this.data.selection = groups;
    this.trigger(this.data);
  },
  removeFromCourse(circleId, courseId) {
    return SteelCompass.request('circle', 'removeFromCourse', {
      circleId,
      courseId
    }).then(
      () => {
        GroupActions.removeFromCourseComplete(circleId);
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },
  removeFromCourseComplete(circleId) {
    AppActions.translatableMessage('group.courseRemoved');
    GroupActions.findById(circleId);
  },
  onRemoveFromSelection(groupId) {
    var dirty = false;
    const { selection } = this.data;
    for (var i = selection.length; i--; ) {
      if (selection[i].id === groupId) {
        selection.splice(i, 1);
        dirty = true;
      }
    }
    if (dirty) {
      this.trigger(this.data);
    }
  },
  onFindById(groupId) {
    return SteelCompass.request('circle', 'findById', { id: groupId }).then(
      group => {
        SteelCompass.request('course', 'findByCircleId', {
          circleId: groupId,
          sortBy: 'name',
          sortMode: 'asc'
        }).then(
          courses => {
            group.courses = courses;
            SteelCompass.request('invitation', 'findByCircleId', {
              circleId: groupId,
              sortBy: 'name',
              sortMode: 'asc'
            }).then(
              invitations => {
                group.invitations = invitations;
                SteelCompass.request('user', 'findByCircleId', {
                  circleId: groupId,
                  sortBy: 'name',
                  sortMode: 'asc'
                }).then(
                  students => {
                    group.students = students;
                    GroupActions.findByIdComplete(group);
                  },
                  error => {
                    GroupActions.genericError(error);
                  }
                );
              },
              error => {
                GroupActions.genericError(error);
              }
            );
          },
          error => {
            GroupActions.genericError(error);
          }
        );
      },
      error => {
        GroupActions.genericError(error);
      }
    );
  },
  onFindByIdComplete(group) {
    this.data.detail = group;
    this.trigger(this.data);
  },
  onDelete(groupId, revokeAccess, callback) {
    return SteelCompass.call(
      'circle',
      'delete',
      { id: groupId, revokeAccess: revokeAccess },
      response => {
        if (callback && !response.isError) {
          callback();
        }
      }
    );
  },
  onCountParticipants(groupIds, callback) {
    return SteelCompass.call(
      'circle',
      'countParticipants',
      { circleIds: groupIds },
      response => {
        this.data.participantCount = response.data.simple;
        this.trigger(this.data);
        if (callback) {
          callback();
        }
      }
    );
  },
  addToCourse(circleId, courseIds, endDate) {
    const now = new Date();
    const ucpPeriod = (endDate - now) / 1000;
    const notify = true;
    if (circleId && circleId > 0) {
      return SteelCompass.request('circle', 'addToCourse', {
        circleId,
        courseIds,
        ucpPeriod,
        notify
      }).then(
        () => {
          GroupActions.addToCourseComplete(circleId);
        },
        error => {
          AppActions.genericError(error);
        }
      );
    }
  },
  addToCourseComplete(circleId) {
    AppActions.translatableMessage('group.coursesAdded');
    GroupActions.findById(circleId);
  }
});

export default GroupStore;



// WEBPACK FOOTER //
// ./src/js/stores/Group.js